
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHome as ObiHomeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-home.js';
 
 
 

 
 export const ObiHome = createComponent({
   react: React,
   tagName: 'obi-home',
   elementClass: ObiHomeElement,
   events: {
     
   }
  });
 
 